/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIReviewBatchItem } from './AIReviewBatchItem';
export type AIReviewBatchRequest = {
  action: AIReviewBatchRequest.action;
  items: Array<AIReviewBatchItem>;
  /**
   * Optional reviewer note persisted as review_reason on every item.
   */
  reason?: string | null;
};
export namespace AIReviewBatchRequest {
  export enum action {
    ACCEPT = 'accept',
    DECLINE = 'decline',
  }
}
